// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2IiVt","validationTips":"StatementDescriptor_validationTips__3eQsI"};